module.exports = __webpack_public_path__ + "static/media/selectOne.10283c69.svg";